<!-- Copyright (c) 2009-2021. Authors: see NOTICE file.

 Licensed under the Apache License, Version 2.0 (the "License");
 you may not use this file except in compliance with the License.
 You may obtain a copy of the License at

      http://www.apache.org/licenses/LICENSE-2.0

 Unless required by applicable law or agreed to in writing, software
 distributed under the License is distributed on an "AS IS" BASIS,
 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 See the License for the specific language governing permissions and
 limitations under the License.-->

<template>
<svg
  xmlns:dc="http://purl.org/dc/elements/1.1/"
  xmlns:cc="http://creativecommons.org/ns#"
  xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
  xmlns:svg="http://www.w3.org/2000/svg"
  xmlns="http://www.w3.org/2000/svg"
  xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
  xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape"
  width="4mm"
  height="4mm"
  viewBox="0 0 14.173228 14.173229"
  id="svg2"
  version="1.1"
  inkscape:version="0.91 r13725"
  sodipodi:docname="free-line.svg"
>
  <defs
    id="defs4"
  />
  <sodipodi:namedview
    id="base"
    pagecolor="#ffffff"
    bordercolor="#666666"
    borderopacity="1.0"
    inkscape:pageopacity="0.0"
    inkscape:pageshadow="2"
    inkscape:zoom="52.572505"
    inkscape:cx="1.7591916"
    inkscape:cy="6.9664237"
    inkscape:document-units="px"
    inkscape:current-layer="layer1"
    showgrid="false"
    inkscape:window-width="1855"
    inkscape:window-height="1056"
    inkscape:window-x="65"
    inkscape:window-y="24"
    inkscape:window-maximized="1"
    fit-margin-top="0"
    fit-margin-left="0"
    fit-margin-right="0"
    fit-margin-bottom="0"
  />
  <metadata id="metadata7">
    <rdf:RDF>
      <cc:Work rdf:about="">
        <dc:format>image/svg+xml</dc:format>
        <dc:type rdf:resource="http://purl.org/dc/dcmitype/StillImage" />
        <dc:title />
      </cc:Work>
    </rdf:RDF>
  </metadata>
  <g
    inkscape:label="Layer 1"
    inkscape:groupmode="layer"
    id="layer1"
    transform="translate(-27.016003,-31.914518)"
  >
    <path
      style="fill:none;fill-rule:evenodd;stroke-width:1.36583543;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
      stroke="#000000"
      d="m 28.507424,40.008532 c 0,0 2.07514,5.220154 3.70608,4.821065 2.487226,-0.608621 1.213333,-9.083876 3.706081,-9.642132 1.676478,-0.375451 3.706081,5.096557 3.706081,5.096557"
      id="path4148"
      inkscape:connector-curvature="0"
      sodipodi:nodetypes="cssc"
    />
  </g>
</svg>
</template>

<script>
export default {
  name: 'icon-line-free-hand'
};
</script>
